import HTTP from '@/service/httpservice'
const groupService = new HTTP('/v1/groups')
export default {
  data () {
    return {
      groups: []
    }
  },
  created () {
    groupService.get().then(res => {
      console.log(res)
      this.$set(this, 'groups', res.data)
    }).catch(e => {
      console.error(e)
      console.error(e.message)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/group.mixin.js